<div ngbDropdown #exportDropdown="ngbDropdown" class="export-listing" [autoClose]="true" placement="top-end">
  <div class="common-drop-down dropdown">
    <button class="btn btn-secondary dropdown-toggle d-flex align-items-center gap-2" type="button" id="dropdown-button" ngbDropdownToggle [disabled]="disabled || isExporting">
      @if (isExporting) {
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true">
        </span>
      }
      <span>{{ (isExporting ? 'shared.export.exporting' : 'common.export') | transloco }}</span>
      @if (!isExporting) {
        <i>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.41797 9.33463H7.58464V4.08464H9.33464L7.0013 1.16797L4.66797 4.08464H6.41797V9.33463Z" fill="#9FA1A4" />
            <path
              d="M2.91667 12.8333H11.0833C11.7267 12.8333 12.25 12.3101 12.25 11.6667V6.41667C12.25 5.77325 11.7267 5.25 11.0833 5.25H8.75V6.41667H11.0833V11.6667H2.91667V6.41667H5.25V5.25H2.91667C2.27325 5.25 1.75 5.77325 1.75 6.41667V11.6667C1.75 12.3101 2.27325 12.8333 2.91667 12.8333Z"
              fill="#9FA1A4" />
          </svg>
        </i>
      }
    </button>
    <ul ngbDropdownMenu class="dropdown-menu export-menu" aria-labelledby="dropdown-button">
      <li>
        <a ngbDropdownItem class="dropdown-item" (click)="exportExcel(); exportDropdown.close()"> {{ 'shared.export.asExcel' | transloco }} </a>
      </li>
      <li>
        <a ngbDropdownItem class="dropdown-item" (click)="exportCsv(); exportDropdown.close()"> {{ 'shared.export.asCsv' | transloco }} </a>
      </li>
    </ul>
  </div>
</div>